import React, { useEffect, useState } from "react";

import InputLabel from "@mui/material/InputLabel";
import Select from "react-select";

import { doService } from "../../../services/ServiceHelper";
import { getSchoolTeachers } from "../../../services/SchoolService";

function TeachersSelector({
  school,
  jwt,
  onChange,
  selectedTeachers,
  label = "Select Teacher(s)",
}) {
  const [_allTeachers, setAllTeachers] = useState([]);

  useEffect(() => {
    initStudents();
  }, []);

  const initStudents = () => {
    doService(getSchoolTeachers(school, jwt), (results) => {
      const rows = results.data;
      const allTeachers = [];

      // put students in buckets
      for (let row of rows) {
        allTeachers.push({
          label: `${row.last_name}, ${row.first_name}`,
          value: row.eid,
        });
      }

      setAllTeachers(allTeachers);
    });
  };

  const handleChangeTeachers = (value) => {
    if (onChange) {
      onChange(value);
    }
  };

  return (
    <>
      <InputLabel>{label}</InputLabel>
      <Select
        menuPortalTarget={document.body}
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        }}
        options={_allTeachers}
        onChange={handleChangeTeachers}
        value={selectedTeachers}
        isMulti={true}
      />
    </>
  );
}

export default TeachersSelector;
